import App from './App.svelte';

const div = document.createElement('div');
document.currentScript.parentElement.insertBefore(div, document.currentScript);

export default new App({ target: div });